import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { translateIfKey } from "../../../domain/helper/i18n.helper";

@Pipe({
	name: "stateReplace",
	standalone: true,
	pure: false,
})
export class StateReplacePipe implements PipeTransform {
	constructor(private readonly translocoService: TranslocoService) {}

	transform(value: string): string {
		if (!value) return value;
		const regex = /\$status\((.*?)\)/g;
		return value.replace(regex, (_match, p1) =>
			translateIfKey(
				this.translocoService,
				`notifications.orderStatus.${p1}`,
				p1,
			),
		);
	}
}
